"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMASH_ENV = exports.AWS_REGION = exports.pathRegexp = exports.comma = exports.slash = exports.separator = exports.spacer = exports.star = exports.underscore = exports.dash = exports.wildcard = exports.effects = exports.scopes = exports.httpMethods = exports.envs = exports.regions = void 0;
exports.regions = {
    us_east_1: 'us-east-1',
    us_east_2: 'us-east-2',
    us_west_1: 'us-west-1',
    us_west_2: 'us-west-2',
    ap_south_1: 'ap-south-1',
    ap_northeast_3: 'ap-northeast-3',
    ap_northeast_2: 'ap-northeast-2',
    ap_southeast_1: 'ap-southeast-1',
    ap_southeast_2: 'ap-southeast-2',
    ap_northeast_1: 'ap-northeast-1',
    ca_central_1: 'ca-central-1',
    eu_central_1: 'eu-central-1',
    eu_west_1: 'eu-west-1',
    eu_west_2: 'eu-west-2',
    eu_west_3: 'eu-west-3',
    eu_north_1: 'eu-north-1',
    sa_east_1: 'sa-east-1',
    af_south_1: 'af-south-1',
    ap_east_1: 'ap-east-1',
    ap_south_2: 'ap-south-2',
    ap_southeast_3: 'ap-southeast-3',
    eu_south_1: 'eu-south-1',
    eu_south_2: 'eu-south-2',
    eu_central_2: 'eu-central-2',
    me_south_1: 'me-south-1',
    me_central_1: 'me-central-1',
};
exports.envs = {
    prod: 'prod',
    dev: 'dev',
    test: 'test',
};
exports.httpMethods = {
    get: 'GET',
    post: 'POST',
    put: 'PUT',
    patch: 'PATCH',
    delete: 'DELETE',
    head: 'HEAD',
    options: 'OPTIONS',
};
exports.scopes = {
    public: 'public',
    private: 'private',
    Public: 'Public',
    Private: 'Private',
};
exports.effects = {
    allow: 'Allow',
    deny: 'Deny',
};
exports.wildcard = '.*';
exports.dash = '-';
exports.underscore = '_';
exports.star = '*';
exports.spacer = ' ';
exports.separator = ':';
exports.slash = '/';
exports.comma = ',';
exports.pathRegexp = '[^\/]+';
exports.AWS_REGION = 'AWS_REGION';
exports.SMASH_ENV = 'ENV';
